import {Component, Input,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';

export interface OutdatedCartMessage {
  outdatedCartMessage: string;
}

@Component({
  selector: 'dcp-outdated-cart-message',
  templateUrl: './outdated-cart-message.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OutdatedCartMessageComponent {
  @Input() message: string;
  @Input() isShown: boolean = true;

  closeMessage() {
    this.isShown = false;
  }
}
